module.exports = __webpack_public_path__ + "static/img/php.d27278d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/php.png
// module id = KpuJ
// module chunks = 0